"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestProductActivation = void 0;

var _MerchandiseIdsToUpgradeProducts = require("self-service-api/constants/MerchandiseIdsToUpgradeProducts");

var _requestNotificationsApi = require("ui-addon-upgrades/_core/common/api/requestNotificationsApi");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _wrapWithErrorMonitoring = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring"));

var _getUpgradeLink = require("ui-addon-upgrades/_core/common/adapters/getUpgradeLink");

var requestProductActivation = (0, _wrapWithErrorMonitoring.default)('requestProductActivation', function (_ref) {
  var merchandiseId = _ref.merchandiseId,
      productName = _ref.productName;
  var cta = (0, _getUpgradeLink.getUpgradeLink)({
    source: 'admin-product-activation-request',
    upgradeProduct: _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId]
  });
  return (0, _requestNotificationsApi.sendRequestProductActivationNotification)(productName, cta).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request product activation notification succeeded',
      merchandiseId: merchandiseId
    });
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request product activation notification failed',
      merchandiseId: merchandiseId
    });

    if (window.Raven) {
      window.Raven.captureMessage('Request product activation notification failed', {
        extra: {
          error: e
        }
      });
    }
  });
});
exports.requestProductActivation = requestProductActivation;